import styled from 'styled-components'
import { TABLET_BREAKPOINT } from 'styles/breakpoints'

export const SearchPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: scroll;
  overflow-x: hidden;
  padding-right: 5px;
  overscroll-behavior: contain;
`

export const SearchPageHeader = styled.div`
  width: 100%;
  position: relative;
  z-index: 10;
  min-height: 48px;
  display: flex;
  align-items: center;

  @media screen and (max-width: ${TABLET_BREAKPOINT}px) {
    display: none;
  }
`

export const SearchJobCardWrapper = styled.div`
  margin-bottom: 10px;
`
